import { render, staticRenderFns } from "./MenuCatGrid.vue?vue&type=template&id=a699a55c&scoped=true&"
import script from "./MenuCatGrid.vue?vue&type=script&lang=js&"
export * from "./MenuCatGrid.vue?vue&type=script&lang=js&"
import style0 from "./MenuCatGrid.vue?vue&type=style&index=0&id=a699a55c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a699a55c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
